const AUTH_TOKEN_KEY = 'admin_token';

export function getAdminToken(): string | null {
  return sessionStorage.getItem(AUTH_TOKEN_KEY);
}

export function storeAdminToken(token: string): void {
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
}

export function isAdminAuthenticated(): boolean {
  const token = getAdminToken();
  if (!token) return false;

  // Token format: "{expiryUnixSeconds}:{hmacHex}"
  const colonIndex = token.indexOf(':');
  if (colonIndex === -1) return false;

  const expiry = parseInt(token.substring(0, colonIndex), 10);
  if (isNaN(expiry)) return false;

  return Math.floor(Date.now() / 1000) < expiry;
}
